import React from 'react';
import PropTypes from 'prop-types';
import MatchDetailPlayerCard from '../MatchDetailPlayerCard/MatchDetailPlayerCard';
import './_MatchDetailPlayersCardsTable.scss';

const buildRows = (items, size) => {
  const rows = [];

  for (let index = 0; index < items.length; index += size) {
    rows.push(items.slice(index, index + size));
  }

  return rows;
};

const MatchDetailPlayersCardsTable = ({ players, statKeys }) => {
  const rows = buildRows(players, 2);

  return (
    <div className="match-detail-players-cards-table">
      {rows.map((row, rowIndex) => (
        <div key={`players-row-${rowIndex}`} className="match-detail-players-cards-table__row">
          <div className="match-detail-players-cards-table__cell">
            <MatchDetailPlayerCard player={row[0]} statKeys={statKeys} />
          </div>
          <div className="match-detail-players-cards-table__cell">
            {row[1] ? <MatchDetailPlayerCard player={row[1]} statKeys={statKeys} /> : <span className="match-detail-players-cards-table__empty" />}
          </div>
        </div>
      ))}
    </div>
  );
};

MatchDetailPlayersCardsTable.propTypes = {
  players: PropTypes.array,
  statKeys: PropTypes.array
};

MatchDetailPlayersCardsTable.defaultProps = {
  players: [],
  statKeys: []
};

export default MatchDetailPlayersCardsTable;



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/FootballMatchDetail/Components/MatchDetailPlayersCardsTable/MatchDetailPlayersCardsTable.jsx